<div class="dialog">
  <img src="assets/img/auth/verification-failed.svg" alt="" class="dialog__img" />
  <p class="dialog__title">لم نتمكن من التحقق من رقم هاتفك!</p>
  <p class="dialog__body">يرجى المحاولة في وقتٍ لاحق</p>
</div>
